/* eslint-disable jira/naming/disallow-filenames */
import React from 'react';
import type ServicedeskReportsCustomEditType from '@jira/spa-apps__servicedesk-reports-custom-edit/src/ServicedeskReportsCustomEditType.tsx';
import { markAsProductBundleReady } from '@jira/platform__spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@jira/platform__spa/src/view/lazy-page/index.tsx';
import { lazyForPaint, type LazyComponent } from '@atlassian/react-loosely-lazy';
import type { RouteContext } from '@atlassian/react-resource-router';

export const LazyServicedeskReportsCustomEdit: LazyComponent<() => React.JSX.Element> =
	lazyForPaint<typeof ServicedeskReportsCustomEditType>(() =>
		markAsProductBundleReady(
			import(
				/* webpackChunkName: "async-servicedesk-reports-custom-edit", jiraSpaEntry: "async-servicedesk-reports-custom-edit" */ '@jira/spa-apps__servicedesk-reports-custom-edit/src/ServicedeskReportsCustomEditType.tsx'
			),
		),
	);

const AsyncServicedeskReportsCustomEdit = ({ match }: RouteContext): React.JSX.Element => {
	const { reportId } = match.params;
	return (
		<LazyPage
			Page={LazyServicedeskReportsCustomEdit}
			pageId={`spa-apps/servicedesk/reports/custom/${reportId || ''}`}
			shouldShowSpinner
		/>
	);
};

export default AsyncServicedeskReportsCustomEdit;
